import { Component, OnInit } from "@angular/core";
import { ICUserService } from "../../services/icuser.service";
import { Router } from "@angular/router";
import { ICUser } from "../../models/entities/icuser";
import {
  ToasterService,
  ToasterConfig,
  BodyOutputType,
  Toast,
} from "angular2-toaster/angular2-toaster";
import { TranslateService } from "@ngx-translate/core";
import * as _ from "underscore";
import { ICMenuService } from "../../services/icmenu.service";
import { ICMenuFilter } from "../../models/filters/icmenu.filter";

@Component({
  selector: "app-login",
  templateUrl: "login.component.html",
})
export class LoginComponent implements OnInit {
  User: ICUser = new ICUser();
  IsChrome: true;

  public toasterconfig: ToasterConfig = new ToasterConfig({
    tapToDismiss: true,
    timeout: 5008888880,
  });

  constructor(
    private userSrv: ICUserService,
    private router: Router,
    private translateSrv: TranslateService,
    private toasterSrv: ToasterService,
    private menuSrv: ICMenuService,
  ) {
    this.IsChrome =
      (<any>window).chrome &&
      ((<any>window).chrome.runtime || (<any>window).chrome.app);
  }

  onSubmit() {
    this.userSrv.login(this.User).then((cd) => {
      if (cd && cd.Success) {
        this.menuSrv
          .list(new ICMenuFilter({ UserId: cd.ObjectResult.Id }))
          .then((r) => {
            const tmpList = r.ListResult.sort((a, b) => a.Order - b.Order);
            if (tmpList.filter((t) => t.Url === "/control").length > 0) {
              this.router.navigateByUrl("/control");
            } else {
              this.router.navigateByUrl(tmpList.filter((t) => t.Url)[0].Url);
            }
          });
      } else {
        const promises = [];
        Object.keys(cd.Errors).forEach((key) => {
          if (!cd.Errors[key].Warning) {
            promises.push(
              new Promise((resolve, reject) => {
                this.translateSrv.get(cd.Errors[key].Message).subscribe((r) => {
                  return resolve({ Text: r, Data: cd.Errors[key].Data });
                });
              }),
            );
          }
        });
        Promise.all(promises).then((list) => {
          this.translateSrv.get("ERROR").subscribe((s) => {
            var message = "";
            if (list.length > 1) {
              var listGrouppted = _.groupBy(list, (e) => e.Text);
              Object.keys(listGrouppted).forEach((element) => {
                message +=
                  "<b>" +
                  element +
                  ":</b><br>" +
                  listGrouppted[element]
                    .map((t) => (t.Data ? " - " + t.Data : ""))
                    .join("<br>") +
                  "<hr>";
              });
            } else {
              message = list[0].Text;
            }
            var toast: Toast = {
              type: "error",
              body: message,
              bodyOutputType: BodyOutputType.TrustedHtml,
              title: s,
            };
            this.toasterSrv.pop(toast);
          });
        });
      }
    });
  }

  ngOnInit(): void {
    this.userSrv.current().then((e) => {
      if (e != null) {
        this.menuSrv.list(new ICMenuFilter({ UserId: e.Id })).then((r) => {
          const tmpList = r.ListResult.sort((a, b) => a.Order - b.Order);
          if (tmpList.filter((t) => t.Url === "/control").length > 0) {
            this.router.navigateByUrl("/control");
          } else {
            this.router.navigateByUrl(tmpList.filter((t) => t.Url)[0].Url);
          }
        });
      }
    });
  }
}
